import React from 'react';
import { Button } from '@soluto-design/react';
import { LinkProps } from '@soluto-design/link';
import BannerSection, { BannerSectionProps } from '../BannerSection';

export interface BannerLargeSectionProps extends BannerSectionProps {
    cta?: LinkProps;
    ctaSecondary?: LinkProps;
}

export default function BannerLargeSection({
    cta,
    ctaSecondary,
    ...props
}: BannerLargeSectionProps) {
    return (
        <BannerSection {...props}>
            {(cta || ctaSecondary) && (
                <div className="flex flex-col md:flex-row gap-sm pt-huge">
                    {!!cta && (
                        <Button variant="primary" size="large" {...cta} />
                    )}
                    {!!ctaSecondary && (
                        <Button
                            variant="secondary"
                            size="large"
                            {...ctaSecondary}
                        />
                    )}
                </div>
            )}
        </BannerSection>
    );
}
